module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_8004.21ce2097.png";